import DOMPurify from 'dompurify';

const notificationHtmlOptions = {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['button', 'embed', 'form', 'iframe', 'input', 'object', 'option', 'select', 'style', 'textarea'],
    FORBID_ATTR: ['style'],
};

export function sanitizeNotificationHtml(html) {
    return DOMPurify.sanitize(html || '', notificationHtmlOptions);
}
